import ClientModule from "@gqlapp/module-client-react";
import qrcode from "./qrcode";

export default new ClientModule({
	popupComponents: [{ component: qrcode }]
});
